import styled from 'styled-components';

export const Wrapper = styled.div``;

export const Content = styled.div``;

export const Info = styled.div`
    color: #00000073;
    padding: 4px 0px;
`;

export const Item = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 10px;
`;

export const Index = styled.div`
    flex: 60px 0 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

export const Config = styled.div`
    flex: auto 1 0;
    padding: 16px;
    background-color: rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: stretch;
    gap: 10px;
`;

export const Remove = styled.div``;

export const Add = styled.div``;
